/* eslint-disable space-before-function-paren */
/**
 *
 * DrillDown
 *
 */

import "./index.less"
import imgActionPlanPromo from "../../images/action_plan-promo.png"
import imgImpactPromo from "../../images/impact-promo.png"

import {
  LOCAL_ACTIVE_ROL,
  isModeInModuleBySlug,
  isAdmin,
} from "../../utils/storage"
import {
  LeftOutlined,
  QuestionCircleFilled,
  RightOutlined,
} from "@ant-design/icons"
import { Button, Popover, Spin, Tooltip } from "antd"
import React, { Component } from "react"
import { get, map } from "lodash"

import Bubbles from "../Bubbles"
import {
  ROLE_LEADER,
  ACTION_PLANS,
  PROMO,
  DISABLE,
  IMPACT_ANALYSIS,
  ENABLE,
} from "utils/constants"
import imgMark from "images/mark_item.svg"
import imgWarning from "../../images/warning.svg"
import starIcon from "../../images/star_promo.svg"
import ModalContact from "../ModalContact"
import ModalActionPlanCreate from "../ModalActionPlanCreate"
import { loadTexts } from "../../utils/i18n"

var isEqual = function(value, other) {
  // eslint-disable-line
  // Get the value type
  const type = Object.prototype.toString.call(value)

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false

  // If items are not an object or array, return false
  if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false

  // Compare the length of the length of the two items
  const valueLen =
    type === "[object Array]" ? value.length : Object.keys(value).length
  const otherLen =
    type === "[object Array]" ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // Compare two items
  const compare = function(item1, item2) {
    // eslint-disable-line
    // Get the object type
    const itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false
    }

    // Otherwise, do a simple comparison
    else {
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === "[object Function]") {
        if (item1.toString() !== item2.toString()) return false
      } else if (item1 !== item2) return false
    }
  }

  // Compare properties
  if (type === "[object Array]") {
    for (let i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  // If nothing failed, return true
  return true
}

class DrillDown extends Component {
  intlWidgetResultByTeam = loadTexts("reports_general_view").reportAmbassador
    .leadershipMeasurement.widgetResultByTeam

  t = undefined
  id = Math.random()
    .toString(36)
    .substr(2, 9)

  start = 100
  state = {
    leyendVisible: true,
    bars: [],
    isVisiblePromoActionsPlans: false,
    isVisibleCreateActionsPlans: false,
    visibleModalPromo: false,
  }

  componentDidUpdate(prevProps) {
    const { dataAll, dataCurrent } = this.props
    const renderBar = dataCurrent.length > 0 ? dataCurrent : dataAll
    const renderBarCurrent =
      prevProps.dataCurrent.length > 0
        ? prevProps.dataCurrent
        : prevProps.dataAll
    if (!isEqual(renderBar, renderBarCurrent)) {
      this.setState({ bars: [] }, () => {
        this.setState(
          { bars: dataCurrent.length > 0 ? dataCurrent : dataAll },
          () => {
            document.querySelector(
              `#DrillDown_${this.id} #myChart`
            ).scrollLeft = 0
            this.reloadRows()
            this.scrollers()
          }
        )
      })
    }
  }

  componentDidMount() {
    const { dataAll, dataCurrent } = this.props
    this.setState({ bars: [] }, () => {
      this.setState(
        { bars: dataCurrent.length > 0 ? dataCurrent : dataAll },
        () => {
          document.querySelector(
            `#DrillDown_${this.id} #myChart`
          ).scrollLeft = 0
          this.reloadRows()
          this.scrollers()
        }
      )
    })
    document.querySelector(`#DrillDown_${this.id} #myChart`).onscroll = () =>
      this.scrollers()
    window.addEventListener("resize", this.scrollers)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.scrollers)
  }

  reloadRows = () => {
    const barWidthDefault = 80
    const chart = document.querySelector(`#DrillDown_${this.id} .chart`)
    const totalBars = document.querySelectorAll(`#DrillDown_${this.id} .bar`)
      .length
    const percentDivs = document.querySelectorAll(
      `#DrillDown_${this.id} .bar-percent`
    )
    let barsTotal = 0
    let currentBar = 0
    percentDivs.forEach((percentDiv) => {
      const barPercent = Math.floor(percentDiv.textContent.replace("%", ""))
      const { anonymityvalid } = percentDiv.parentNode.dataset
      percentDiv.parentNode.style.setProperty(
        "grid-row-start",
        (barPercent ? 101 : 100) - `${isNaN(barPercent) ? 1 : barPercent}`
      )
      if (anonymityvalid == "false") {
        percentDiv.parentNode.style.setProperty("grid-row-start", 1)
        percentDiv.parentNode.style.setProperty("background", "#D9D9D9")
      }
      currentBar =
        percentDiv.offsetWidth > 150 ? barWidthDefault : percentDiv.offsetWidth
      barsTotal += currentBar === 100 ? currentBar + 80 : currentBar + 40
    })
    if (percentDivs[0]) {
      const widthBar = barsTotal // 40 de los margenes
      const widthBarTotal = widthBar + 10
      chart.style.width = `${widthBarTotal + (totalBars * 10 - 10)}px` //  suma de totales de barra + (total de barras por 10 -- gap -- menos el gap )
      chart.style.setProperty(
        "grid-template-columns",
        `repeat(${totalBars}, min-content)`
      )
    }
  }

  sideScroll = (direction, type) => {
    if (type === "up") {
      clearTimeout(this.t)
      this.start = 100
    } else {
      const element = document.querySelector(`#DrillDown_${this.id} #myChart`)
      if (direction == "left") {
        element.scrollLeft -= 3
      } else {
        element.scrollLeft += 3
      }
      this.t = setTimeout(() => this.sideScroll(direction, type), this.start)
      this.start /= 2
    }
  }

  scrollers = () => {
    const chart = document.querySelector(`#DrillDown_${this.id} #myChart`)
    const innerChart = document.querySelector(
      `#DrillDown_${this.id} #myChart_inner`
    )
    const percentDivs = document.querySelectorAll(
      `#DrillDown_${this.id} .bar-percent`
    )
    const formComparate = chart.scrollLeft + chart.offsetWidth
    if (percentDivs[0]) {
      if (
        percentDivs[0].offsetWidth > 150 ||
        formComparate <= innerChart.offsetWidth
      ) {
        if (chart.scrollLeft == 0) {
          document.querySelector(
            `#DrillDown_${this.id} .scrollLeft`
          ).style.opacity = 0
        } else {
          document.querySelector(
            `#DrillDown_${this.id} .scrollLeft`
          ).style.opacity = 1
        }
        if (chart.scrollLeft + chart.offsetWidth == innerChart.offsetWidth) {
          document.querySelector(
            `#DrillDown_${this.id} .scrollRight`
          ).style.opacity = 0
        } else {
          document.querySelector(
            `#DrillDown_${this.id} .scrollRight`
          ).style.opacity = 1
        }
      } else {
        document.querySelector(
          `#DrillDown_${this.id} .scrollRight`
        ).style.opacity = 0
        document.querySelector(
          `#DrillDown_${this.id} .scrollLeft`
        ).style.opacity = 0
      }
    }
  }

  onClickBar = (e) => {
    this.props.onClickBar(e)
  }

  popoverAmbassador = (e) => {
    return (
      <div>
        <div
          style={{
            borderBottom: "1px solid #ECEAEA",
            padding: "10px",
          }}>
          {(!e.employees || !e.anonymity_check.valid
            ? undefined
            : e.flag != "MDMT") || e.anonymity
            ? `${e.employees} colaboradores`
            : undefined}

          {!e.anonymity_check.valid && (
            <p style={{ textAlign: "center", marginBottom: "0px" }}>
              El total de colaboradores debe ser
              <br />
              mayor o igual a {e.anonymity_check.current_used} para poder
              mostrar la
              <br />
              información del segmento.
            </p>
          )}
        </div>
        {e.employees >= 25 && (
          <div style={{ padding: "10px" }}>
            <div className="card-x-ambassador__title">
              Embajadores ({e.ambassadors.length})
            </div>
            {map(e.ambassadors, (item, index) => {
              return (
                <div className="card-x-ambassador__item" key={index}>
                  <img src={item.profile_picture} alt={item.profile_picture} />
                  <div>
                    <div className="card-x-ambassador__item-title">
                      {item.full_name}
                    </div>
                    <div className="card-x-ambassador__item-subtitle">
                      {" "}
                      {item.position_name}{" "}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }

  setNameMetricsTotalLabel = (item) => {
    const { measure_general } = this.props
    let hasData = get(measure_general, "metric_total_label", null)
    let surveyType = get(measure_general, "id_survey_type", null)
    let response = item.name
    if (hasData !== null && surveyType === 1 && item.first) {
      response = get(measure_general, "metric_total_label", null)
    }

    return response
  }

  renderModalPromo() {
    const { isVisiblePromoActionsPlans } = this.state
    return (
      <ModalContact
        isModalVisible={isVisiblePromoActionsPlans}
        titleModal="¿Te gustaría contar con Planes de Acción para tus usuarios?"
        contentModal={
          <div>
            <p>
              Un <strong>plan de acción</strong> es una estrategia que busca
              mejorar los resultados de tu organización a través de acciones
              concretas. Los planes te permitirán:
            </p>
            <ul className="list-plan-action">
              <li>
                <strong>Crear tareas</strong> asignadas a distintos usuarios y
                <strong> monitorear su progreso en el tiempo.</strong>
              </li>
              <li>
                {" "}
                Direccionar las acciones hacia{" "}
                <strong>dimensiones específicas.</strong>
              </li>
              <li>
                Crear <strong>recomendaciones</strong> que luego podrán ser
                utilizadas por el resto de usuarios en tu organización.
              </li>
            </ul>
            <p>
              Ponte en contacto con nuestro equipo comercial para{" "}
              <strong>acceder a un plan superior</strong> del producto y poder
              hacer uso de esta funcionalidad.
            </p>
          </div>
        }
        handleOk={() => this.setState({ isVisiblePromoActionsPlans: false })}
        handleCancel={() =>
          this.setState({ isVisiblePromoActionsPlans: false })
        }
        imgExampleModal={<img src={imgActionPlanPromo} />}
      />
    )
  }

  renderImprovementOpportunity() {
    const isAdminActive = isAdmin()
    const actionPlans = isModeInModuleBySlug(ACTION_PLANS)
    let contentWarning = (
      <div className="content-warning-action">
        <p>Oportunidad de mejora</p>
      </div>
    )
    if (actionPlans === ENABLE) {
      return null
    }
    if (isAdminActive && actionPlans === PROMO) {
      contentWarning = (
        <div className="content-warning-action-promo">
          <p>
            Se ha identificado una <strong>oportunidad de mejora</strong> en
            esta dimensión.
          </p>
          <Button
            type="link"
            className="action-plan-button"
            onClick={() => {
              if (actionPlans === PROMO) {
                this.setState({ isVisiblePromoActionsPlans: true })
              } else {
                this.setState({ isVisibleCreateActionsPlans: true })
              }
            }}>
            <img src={starIcon} />
            <p>
              ¿Quieres crear un <strong> plan de acción</strong>?
            </p>
          </Button>
        </div>
      )
    }
    return (
      <Popover
        content={contentWarning}
        overlayClassName="ant-popover-improvement_opportunity">
        <div className="bar-improvement_opportunity">
          <img
            src={imgWarning}
            alt="img-warning"
            style={{
              position: "absolute",
              width: 18,
              cursor: "pointer",
              top: -30,
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        </div>
      </Popover>
    )
  }

  renderMinimumOfResponses() {
    const { bubbles, dataCurrent, isDimensions } = this.props
    const isPromo = isModeInModuleBySlug(IMPACT_ANALYSIS) === PROMO
    if (isPromo || !isDimensions) {
      return null
    }
    if (bubbles && get(dataCurrent, "[0].employees", 0) >= 25) {
      return null
    }
    const messageImpact = (
      <div style={{ maxWidth: 400, textAlign: "justify" }}>
        El análisis de <b>Impacto</b> identifica, a través de un modelo
        estadístico de correlación, cuáles son las dimensiones que tienen un
        mayor impacto en el <b>Engagement</b> de la organización. De esta
        manera, la organización podrá crear planes de acción direccionados a
        aquellas dimensiones que tienen una mayor probabilidad de afectar
        directamente el resultado de <b>Engagement</b>.<br />
        Para facilitar su rápida identificación, las dimensiones con un alto
        impacto se encuentran marcadas con un ícono (
        <img height={12} src={imgMark} />
        ).
      </div>
    )
    return (
      <div className="min-25-response">
        <div className="impact">
          IMPACTO{" "}
          <Popover
            placement="right"
            content={messageImpact}
            title="Impacto"
            trigger="hover">
            <QuestionCircleFilled
              style={{
                color: "#D8D8D8",
                verticalAlign: "baseline",
                fontSize: "14px",
              }}
            />
          </Popover>
        </div>
        <div className="message">
          Se requiere de un mínimo de 25 respuestas para poder calcular el
          impacto.
        </div>
      </div>
    )
  }

  renderPromo() {
    const { isDimensions } = this.props
    const isPromo = isModeInModuleBySlug(IMPACT_ANALYSIS) === PROMO
    if (!isPromo || !isDimensions) {
      return null
    }
    return (
      <div className="impact_promo">
        <Button
          type="link"
          className="impact_promo-button"
          onClick={() => this.setState({ visibleModalPromo: true })}>
          <img src={starIcon} />
          <p>
            ¿Qué dimensiones tienen mayor <strong> impacto </strong> en el
            Engagement?
          </p>
        </Button>
      </div>
    )
  }

  renderModalPromoImpact() {
    const { visibleModalPromo } = this.state
    return (
      <ModalContact
        isModalVisible={visibleModalPromo}
        titleModal="¿Te gustaría saber qué dimensiones tienen mayor impacto en el Engagement de tu organización?"
        contentModal={
          <div>
            A través de nuestro modelo estadístico de correlación, podrás
            saberlo para determinar en qué <strong>dimensiones</strong> trabajar
            para obtener <strong>mejores resultados.</strong> <br /> <br />
            Ponte en contacto con nuestro equipo comercial para{" "}
            <strong>acceder a un plan superior</strong>
            del producto y poder hacer uso de esta funcionalidad.
          </div>
        }
        handleOk={() => this.setState({ visibleModalPromo: false })}
        handleCancel={() => this.setState({ visibleModalPromo: false })}
        imgExampleModal={<img src={imgImpactPromo} />}
      />
    )
  }

  render() {
    const {
      isLoading,
      lineValue,
      bubblesNumber,
      dataParent,
      loading,
      bubbles,
      textLeyend,
    } = this.props
    const { leyendVisible, bars } = this.state
    const renderBar = bars

    const messageImpact = (
      <div style={{ maxWidth: 400, textAlign: "justify" }}>
        El análisis de <b>Impacto</b> identifica, a través de un modelo
        estadístico de correlación, cuáles son las dimensiones que tienen un
        mayor impacto en el <b>Engagement</b> de la organización. De esta
        manera, la organización podrá crear planes de acción direccionados a
        aquellas dimensiones que tienen una mayor probabilidad de afectar
        directamente el resultado de <b>Engagement</b>.<br />
        Para facilitar su rápida identificación, las dimensiones con un alto
        impacto se encuentran marcadas con un ícono (
        <img height={12} src={imgMark} />
        ).
      </div>
    )

    let messageBarAnonymity = (e) => (
      <>
        El total de colaboradores debe ser
        <br /> mayor o igual a <b>{e.anonymity_check.current_used}</b>
        <br />
        para poder mostrar la
        <br />
        información del segmento.
      </>
    )
    if (LOCAL_ACTIVE_ROL() == ROLE_LEADER.toString()) {
      messageBarAnonymity = (e) => (
        <>
          El total de colaboradores debe ser
          <br /> mayor o igual a <b>{e.anonymity_check.current_used}</b>
          <br />
          para poder mostrar los
          <br />
          resultados del líder.
        </>
      )
    }

    if (isLoading) return <div>Cargando</div>
    const isActionPlans = isModeInModuleBySlug(ACTION_PLANS) !== DISABLE
    const isPromo = isModeInModuleBySlug(IMPACT_ANALYSIS) === PROMO
    const { measure_general } = this.props
    return (
      <div className="DrillDownComponent" id={`DrillDown_${this.id}`}>
        {loading && (
          <div className="loadingCss">
            <div style={{ position: "relative", top: "50%" }}>
              <Spin size="large" />
            </div>
          </div>
        )}
        <div className="DrillDown">
          {dataParent.id != null && (
            <div
              className="goBack"
              onClick={(e) => this.props.onClickBack(dataParent)}>
              {" "}
              <span>
                {" "}
                <LeftOutlined /> {this.intlWidgetResultByTeam.btnBack}
              </span>
            </div>
          )}
          {lineValue && lineValue.value_visible && (
            <div className="leyend">
              <div className="leyend-line" />
              <div
                onClick={() => {
                  this.setState({ leyendVisible: !leyendVisible })
                }}
                className="leyend-name color-gray-low"
                style={
                  !leyendVisible ? { textDecoration: "line-through" } : {}
                }>
                {textLeyend}
              </div>
            </div>
          )}
          <div className="axis">
            <span>100%</span>
            <span />
            <span>80%</span>
            <span />
            <span>60%</span>
            <span />
            <span>40%</span>
            <span />
            <span>20%</span>
            <span />
            <span>0%</span>
          </div>
          <div
            className="subContent"
            style={bubbles ? { height: 323, overflow: "hidden" } : {}}
            id="myChart">
            <div className="chart" id="myChart_inner">
              {lineValue && lineValue.value_visible && leyendVisible && (
                <div
                  className="lineValue"
                  style={{ bottom: lineValue.value_visible }}>
                  {" "}
                </div>
              )}
              <div className="topLine" />
              {renderBar.map((e, i) => {
                if (e.engagement) return
                return (
                  <div
                    data-employess={e.employees}
                    data-flag={e.flag}
                    data-anonymity={e.anonymity_check.current_used}
                    data-anonymityvalid={e.anonymity_check.valid}
                    key={i}
                    className={`bar${renderBar.length <= 5 ? " bar-long" : ""}${
                      e.is_long ? " bar-color" : ""
                    }`}
                    style={
                      e.childs && e.childs.length > 0
                        ? {
                            cursor: "pointer",
                            color: e.first ? e.color : "",
                            background: e.first ? e.color : "",
                          }
                        : e.first && {
                            color: e.color || "",
                            background: e.color || "",
                          }
                    }>
                    {validRole({ role: [1, 2, 3, 4] }) && e.ambassadors ? (
                      <Popover
                        overlayClassName="card-x-ambassador"
                        content={this.popoverAmbassador(e)}>
                        <div
                          className="bar-line"
                          onClick={() =>
                            e.childs && e.childs.length > 0
                              ? this.onClickBar(e)
                              : null
                          }
                        />
                      </Popover>
                    ) : (
                      <Tooltip
                        placement="top"
                        overlayClassName="tooltipWhite tooltipBarOverlay"
                        title={
                          !e.employees || !e.anonymity_check.valid ? (
                            e.flag != "MDMT" || !e.anonymity_check.valid ? (
                              <p
                                style={{
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}>
                                {messageBarAnonymity(e)}
                              </p>
                            ) : (
                              undefined
                            )
                          ) : e.flag != "MDMT" && this.props.isTooltip ? (
                            <div className="tooltipBarContainer">
                              <div className="tooltipBarContainer-top">
                                <div className="tooltipBarContainer-top-left">
                                  <div className="tooltipBarContainer-top-left-title">
                                    {`${e.name}`}
                                  </div>
                                  <div className="tooltipBarContainer-top-left-employees">
                                    <span style={{ fontWeight: 600 }}>
                                      {e.employees}
                                    </span>
                                    {` de ${e.recipients} colaboradores`}
                                  </div>
                                </div>
                                <div className="tooltipBarContainer-top-right">
                                  <div
                                    className="tooltipBarContainer-top-right-content"
                                    style={{ backgroundColor: e.color }}>
                                    <span>{`${Math.round(e.value)}%`}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : this.props.isTooltip ? (
                            <div className="tooltipBarContainer">
                              <div className="tooltipBarContainer-top">
                                <div className="tooltipBarContainer-top-left">
                                  <div className="tooltipBarContainer-top-left-title">
                                    {`${e.dimension_name}`}
                                  </div>
                                  <div className="tooltipBarContainer-top-left-employees">
                                    <span style={{ fontWeight: 600 }}>
                                      {e.employees}
                                    </span>
                                    {` de ${e.recipients} colaboradores`}
                                  </div>
                                </div>
                                <div className="tooltipBarContainer-top-right">
                                  <div
                                    className="tooltipBarContainer-top-right-content"
                                    style={{ backgroundColor: e.color }}>
                                    <span>{`${Math.round(e.value)}%`}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null
                        }>
                        <div
                          className="bar-line"
                          onClick={() =>
                            e.childs && e.childs.length > 0
                              ? this.onClickBar(e)
                              : null
                          }
                        />
                      </Tooltip>
                    )}
                    {e.is_improvement_opportunity && isActionPlans
                      ? this.renderImprovementOpportunity()
                      : null}
                    <div
                      className="bar-percent"
                      onClick={() =>
                        e.childs && e.childs.length > 0
                          ? this.onClickBar(e)
                          : null
                      }
                      style={{
                        color: (e.first && e.color) || "",
                        display: !e.anonymity_check.valid ? "none" : "",
                      }}>
                      {parseInt(e.percent, 10)}%
                    </div>
                    <div
                      className="bar-name"
                      onClick={() =>
                        e.childs && e.childs.length > 0
                          ? this.onClickBar(e)
                          : null
                      }>
                      <Tooltip
                        placement="bottom"
                        title={this.setNameMetricsTotalLabel(e)}>
                        {this.setNameMetricsTotalLabel(e)}
                      </Tooltip>
                    </div>
                    {bubbles && e.employees > 24 && !e.first && !isPromo ? (
                      <div className="bar-bubble">
                        {e.impact >= 0.5 && (
                          <Tooltip
                            placement="bottom"
                            overlayClassName="tooltipWhite"
                            title="Alto impacto">
                            <img src={imgMark} />
                          </Tooltip>
                        )}
                        {e.impact > 0 ? (
                          <Bubbles
                            left={e.impact}
                            numbers={bubblesNumber}
                            right={e.impact}
                          />
                        ) : (
                          e.employees >= 25 && (
                            <Tooltip title="El impacto no es significativo.">
                              <span style={{ color: "#8D8A8D" }}>-</span>
                            </Tooltip>
                          )
                        )}
                      </div>
                    ) : null}
                    {bubbles && e.first && !isPromo ? (
                      <div className="bar-text">
                        IMPACTO{" "}
                        <Popover
                          placement="right"
                          content={messageImpact}
                          title="Impacto"
                          trigger="hover">
                          <QuestionCircleFilled
                            style={{
                              color: "#D8D8D8",
                              verticalAlign: "baseline",
                              fontSize: 14,
                            }}
                          />
                        </Popover>
                      </div>
                    ) : null}
                  </div>
                )
              })}
            </div>
            {this.renderMinimumOfResponses()}
            {this.renderPromo()}
          </div>
          <div
            className="scrollSide scrollLeft"
            style={
              bubbles
                ? { height: "calc(100% - 1px)", left: 0, opacity: 0 }
                : { left: 0, opacity: 0 }
            }>
            <LeftOutlined
              onMouseUp={() => this.sideScroll("left", "up")}
              onMouseDown={() => this.sideScroll("left", "down")}
              style={{ color: "#979797" }}
            />
          </div>
          <div
            className="scrollSide scrollRight"
            style={
              bubbles
                ? { height: "calc(100% - 1px)", right: 0, opacity: 0 }
                : { right: 0, opacity: 0 }
            }>
            <RightOutlined
              onMouseUp={() => this.sideScroll("right", "up")}
              onMouseDown={() => this.sideScroll("right", "down")}
              style={{ color: "#979797" }}
            />
          </div>
        </div>
        {this.renderModalPromo()}
        {this.renderModalPromoImpact()}
        <ModalActionPlanCreate
          visible={this.state.isVisibleCreateActionsPlans}
          onCancel={() => this.setState({ isVisibleCreateActionsPlans: false })}
        />
      </div>
    )
  }
}

export default DrillDown
